module.exports = __webpack_public_path__ + "static/media/tom_dal.68032bf.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/tom_dal.mp3
// module id = lB3J
// module chunks = 1